import { useState, useEffect } from "react";
import ButtonComponent from "../../../components/Form/ButtonComponent";
import InputComponent from "../../../components/Form/InputComponent";
import Axios from "middleware/axiosInstance";
import Loading from "../../../layouts/Loading/Loading";
import Modal from "../../../layouts/Modal/Modal";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";

const CommodityAndServicesGroup = () => {
  // const [form] = Form.useForm();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [allCommodityAndServicesGroup, setAllCommodityAndServicesGroup] =
    useState(null);
  const [newCommodityAndServicesGroup, setNewCommodityAndServicesGroup] =
    useState({});
  const [editeCommodityAndServicesGroup, setEditeCommodityAndServicesGroup] =
    useState({});

  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setNewCommodityAndServicesGroup({
      ...newCommodityAndServicesGroup,
      [name]: value,
    });
  };

  const changeEditeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setEditeCommodityAndServicesGroup({
      ...editeCommodityAndServicesGroup,
      [name]: value,
    });
  };

  const CreateCommodityAndServicesGroupHandler = () => {
    Axios.post("/goods_groups", newCommodityAndServicesGroup)
      .then((res) => {
        console.log(res);
        getAllCommodityAndServicesGroup();
        setShowAddModal(false);
        OpenNotificationWithIcon(
          "ثبت موفق",
          "گروه کالایی جدید با موفقیت ثبت شد"
        );
        setNewCommodityAndServicesGroup(null);
      })
      .catch((res) => {
        console.log(res);
        if (
          res.response.data.message.name[0] ===
          "The name has already been taken."
        ) {
          OpenNotificationWithIcon(
            "نام  تکراری",
            "نام وارد شده تکراری می باشد",
            "error"
          );
        } else if (
          res.response.data.message.code[0] ===
          "The code has already been taken."
        ) {
          OpenNotificationWithIcon(
            "کد  تکراری",
            "کد وارد شده تکراری می باشد",
            "error"
          );
        } else {
          OpenNotificationWithIcon(
            "ثبت نشد",
            "ثبت گروه جدید انجام نشد",
            "error"
          );
        }
      });
  };

  const editeCommodityAndServicesGroupHandler = () => {
    Axios.put(
      `/goods_groups/${selectedItem.id}`,
      editeCommodityAndServicesGroup
    )
      .then((res) => {
        console.log(res);
        getAllCommodityAndServicesGroup();
        setSelectedItem(null);
      })
      .catch((res) => {
        console.log(res);
      })
      .finally(() => {
        setShowEditModal(false);
        setSelectedItem(null);
        setEditeCommodityAndServicesGroup(null);
      });
  };

  const getAllCommodityAndServicesGroup = () => {
    Axios.get("/goods_groups")
      .then((res) => {
        setAllCommodityAndServicesGroup(res.data);
      })
      .catch(() => {
        setAllCommodityAndServicesGroup(false);
        OpenNotificationWithIcon(
          "خطا در دریافت اطلاعات",
          "لیست گروه کالا و خدمات دریافت نشد",
          "error"
        );
      });
  };

  const deleteCommodityAndServicesGroup = () => {
    Axios.delete(`/goods_groups/${selectedItem.id}`)
      .then(() => {
        getAllCommodityAndServicesGroup();
        OpenNotificationWithIcon("حذف شد", "گروه کالا و خدمات حذف شد");
      })
      .catch((res) => {
        OpenNotificationWithIcon("خطا", "گروه کالا و خدمات حذف نشد", "error");
      })
      .finally(() => {
        setSelectedItem(null);
      });
  };

  useEffect(() => {
    getAllCommodityAndServicesGroup();
  }, []);

  const deleteItemHandler = () => {
    if (window.confirm(`آیا دسته بندی "${selectedItem.name}" حذف گردد؟ \n\n هشدار: \n تمام کالاهای مربوط به این دسته بندی نیز حذف می گردد!\n و اسناد ثبت شده شامل این کالاها نیز حذف می گردند!`)) {
      deleteCommodityAndServicesGroup();
    }
  };
  const handleSelectRow = (item) => {
    setSelectedItem(item);
  };

  // const handleNewFormValuesChange = (changedValues) => {
  //   const formFieldName = Object.keys(changedValues)[0];
  //   setNewCommodityAndServicesGroup({
  //     ...newCommodityAndServicesGroup,
  //     [formFieldName]: changedValues[formFieldName],
  //   });
  // };
  // const handleEditFormValuesChange = (changedValues) => {
  //   const formFieldName = Object.keys(changedValues)[0];
  //   setEditeCommodityAndServicesGroup({
  //     ...editeCommodityAndServicesGroup,
  //     [formFieldName]: changedValues[formFieldName],
  //   });
  // };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        {showAddModal && <Modal>
          <div className="p-4">
            <h6>
              ایجاد گروه کالا و خدمات:
            </h6>
            <InputComponent
              inputName="code"
              inputId="code"
              lableValue="کد:"
              inputType="number"
              onChange={e => handleInputChange(e)}
              inputPlaceholder="123"
            />

            <InputComponent
              inputName="name"
              inputId="name"
              lableValue="نام:"
              onChange={e => handleInputChange(e)}
              inputPlaceholder="سیم و کابل"
            />
            <InputComponent
              inputName="shenaseh"
              inputId="shenaseh"
              lableValue="شناسه:"
              onChange={e => handleInputChange(e)}
              inputPlaceholder="100"
            />

            <div className="d-flex flex-row justify-content-evenly mt-4">
              <ButtonComponent onClick={() => CreateCommodityAndServicesGroupHandler()} value="ثبت" />
              <ButtonComponent onClick={() => setShowAddModal(false)} value="لغو" />
            </div>
          </div>
        </Modal>

        }


        {showEditModal && <Modal>
          <div className="p-4">
            <h6>
              ویرایش گروه
              {` ${selectedItem.name}`}:
            </h6>
            <InputComponent
              inputName="code"
              inputId="code"
              lableValue="کد:"
              inputType="number"
              onChange={e => changeEditeHandler(e)}
              defaultValue={selectedItem.code}
            />

            <InputComponent
              inputName="name"
              inputId="name"
              lableValue="نام:"
              onChange={e => changeEditeHandler(e)}
              defaultValue={selectedItem.name}
            />
            <InputComponent
              inputName="shenaseh"
              inputId="shenaseh"
              lableValue="شناسه:"
              onChange={e => changeEditeHandler(e)}
              defaultValue={selectedItem.shenaseh}
            />

            <div className="d-flex flex-row justify-content-evenly mt-4">
              <ButtonComponent onClick={() => editeCommodityAndServicesGroupHandler()} value="ثبت" />
              <ButtonComponent onClick={() => setShowEditModal(false)} value="لغو" />
            </div>

          </div>
        </Modal>
        }
        <h5 className="title-session">گروه کالا و خدمات</h5>

        <div className='d-flex flex-row '>
          <button className='bi-custom-button'
            onClick={() => setShowAddModal(true)}>
            اضافه کردن
          </button>
          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? setShowEditModal(true)
                : OpenNotificationWithIcon(
                  "خطا",
                  "جهت ویرایش یک مورد را انتخاب فرمایید",
                  "error"
                )
            }
          >ویرایش</button>

          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? deleteItemHandler()
                : //  alert("جهت حذف یک آیتم را انتخاب فرمایید!")
                OpenNotificationWithIcon(
                  "خطا",
                  "جهت حذف یک مورد را انتخاب فرمایید",
                  "error"
                )
            }
          >حذف</button>
        </div>

        {
          allCommodityAndServicesGroup &&
            allCommodityAndServicesGroup.length > 0 ? (
            <table className="bi-table-style bi-row-select-enable col-12 col-md-6 col-lg-4">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>کد</th>
                  <th>نام</th>
                  <th>شناسه</th>
                </tr>
              </thead>
              <tbody>
                {allCommodityAndServicesGroup.map(
                  (CommodityAndServicesGroup, index) => {
                    return (
                      <tr
                        id={CommodityAndServicesGroup.id}
                        key={CommodityAndServicesGroup.id}
                        onClick={() => handleSelectRow(CommodityAndServicesGroup)}
                        className={
                          selectedItem
                            ? CommodityAndServicesGroup.id === selectedItem.id
                              ? "item-slected"
                              : null
                            : null
                        }
                      >
                        <td>{index + 1}</td>

                        <td>{CommodityAndServicesGroup.code}</td>

                        <td>{CommodityAndServicesGroup.name}</td>

                        <td>{CommodityAndServicesGroup.shenaseh}</td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          ) : (
            <Loading />
          )
        }
      </div >
    </div >
  );
};

export default CommodityAndServicesGroup;
